import { Signal } from '../core/Signal';

export interface SessionStartPayload {
  sessionId: string;
  timestamp: number;
}

export interface SessionEndPayload {
  sessionId: string;
  duration: number;
  timestamp: number;
}

export const createSessionSignals = (debugMode: boolean = false) => ({
  sessionStart: new Signal<SessionStartPayload>(
    'session.sessionStart',
    debugMode
  ),
  sessionEnd: new Signal<SessionEndPayload>('session.sessionEnd', debugMode),
});

export type SessionSignals = ReturnType<typeof createSessionSignals>;
